import { fn0nZ, fn2nZ, fn4nZ } from '../../core/formatter/formatNumber';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import { WHelpIcon } from '../../core/elements/WHelpIcon';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';

export interface ZusatztoolsPvWirtschaftlichProps {
    data: any;
    varianten: any[];
    variante: number;
    isExpert?: boolean;
    isPdf?: boolean;
    results: any[];
}

export class ZusatztoolsPvWirtschaftlich extends React.Component<ZusatztoolsPvWirtschaftlichProps, {}> {

    constructor(props: any) {
        super(props);
        this.state = {};
    }

    getStyle(): any {
        const isPdf: boolean = this.props.isPdf || false;
        const isExpert: boolean = this.props.isExpert || false;
        const Section: any = new SectionStyle();

        return ({
            tabelle: {
                fontSize: '9pt',
                maxWidth: 720,
                marginTop: 15,
                border: '1pt solid white',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                color: '#555',
                backgroundColor: '#ddd',
                display: 'flex',
                flexDirection: 'row',
                flex: 1,
                boxSizing: 'border-box'
            },
            row_header: {
                ...(isPdf && { fontFamily: 'Helvetica-Bold' }),
                fontWeight: 'bold',
                color: Section.getPropertyValue('--color-button-text') || '#555',
                backgroundColor: Section.getPropertyValue('--color-section-main') || '#bccae3'
            },
            col_active: {
                color: Section.getPropertyValue('--color-button-text') || 'white',
                backgroundColor: Section.getPropertyValue('--color-section-table-header-highlight') || '#6692c3'
            },
            col1: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: isPdf
                    ? isExpert ? '41.25%' : '47.5%'
                    : isExpert ? '32.5%' : '50%'
            },
            col1_header: {
            },
            col2: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: isPdf
                    ? (isExpert ? '11.75%' : '26.25%')
                    : (isExpert ? '13.5%' : '25%')
            },
            col2_header: {
            },
            col3: {
                display: 'flex',
                flex: 1,
                flexDirection: 'column',
                flexBasis: '22.5%'
            },
            col3_header: {
            },
            cell: {
                textAlign: 'left',
                padding: isPdf ? 2 : 4,
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                ...(!isPdf && { alignItems: 'center' }),
                boxSizing: 'border-box'
            },
            cell_header: {
                borderTop: 0,
                ...(!isPdf && { alignItems: 'flex-start' })
            },
            cell1: {
                borderLeft: 0
            },
            cell1_header: {
                borderLeft: 0
            },
            cell2: {
                textAlign: 'center',
                justifyContent: 'center'
            },
            cell2_header: {
            },
            hinweis: {
                fontSize: '9pt',
                margin: '15px 20px 0 20px',
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            normal: {
                ...(isPdf && { fontFamily: 'Helvetica' }),
                fontWeight: 'normal'
            }
        });
    }

    getData(): any {
        const results: any[] = this.props.results || [];

        if (!results.length) {
            return {};
        }
        const data: any = {
            investitions_kosten: {
                name: 'geschätzte Investitionskosten',
                values: results.map((result: any) => {
                    const investitions_kosten: number = (result.wirtschaftlich || {}).investitions_kosten || null;
                    return investitions_kosten ? fn2nZ(investitions_kosten) + ' €' : '';
                })
            },
            anlagenkosten: {
                name: 'spezifische Anlagenkosten',
                values: results.map((result: any) => {
                    const anlagenkosten: number = (result.wirtschaftlich || {}).anlagenkosten || null;
                    return anlagenkosten ? fn2nZ(anlagenkosten) + ' €' : '';
                })
            },
            amortisierungszeit: {
                name: 'Amortisierungszeit [Jahre]',
                values: results.map((result: any) => {
                    const val = (result.wirtschaftlich || {}).ammortisation;
                    return val <= 20 ? fn0nZ(val) : '> 20';
                })
            },
            stromgestehungs_kosten: {
                name: 'Stromgestehungskosten',
                values: results.map((result: any) => {
                    const stromgestehungs_kosten: number = (result.wirtschaftlich || {}).stromgestehungs_kosten || null;
                    return stromgestehungs_kosten ? fn2nZ(stromgestehungs_kosten) + ' €' : '';
                })
            },
            zinsfuss_intern: {
                name: 'interner Zinsfuß',
                values: results.map((result: any) => {
                    const zinsfuss_intern: number = (result.wirtschaftlich || {}).interner_zinsfuss || null;
                    return zinsfuss_intern ? fn2nZ(zinsfuss_intern * 100) + '%' : '';
                })
            },
            einspeiseverguetung: {
                name: 'Einspeisevergütung',
                values: results.map((result: any) => {
                    const einspeiseverguetung: number = (result.wirtschaftlich || {}).einspeiseverguetung || null;
                    return einspeiseverguetung ? fn4nZ(einspeiseverguetung) + ' €' : '';
                })
            }
        };

        if (!this.props.isExpert) {
            delete data.anlagenkosten;
            delete data.einspeiseverguetung;
        }

        return data;
    }

    render(): JSX.Element {
        return this.props.data
            ? <>{this.renderTabelle()}</>
            : null;
    }

    renderErgebnisse(data: any): JSX.Element[] {
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        return Object.keys(data || {}).map((key: any) => {
            const eintrag: any = data[key] || {};
            const values: any[] = eintrag.values || [];
            return (
                <WpdfView key={`eintrag-${key}`} style={{...styles.row}} pdf={isPdf}>
                    <WpdfView style={{...styles.col1}} pdf={isPdf}>
                        <WpdfView style={{...styles.cell, ...styles.cell1}} pdf={isPdf}>
                            {!isPdf &&
                                this.renderHelpIcon(`pvtool_wirtschaftlich_${key}`, eintrag.name || null)
                            }
                            <WpdfText pdf={isPdf}>{eintrag.name || null}</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    {this.props.varianten.map((variante: any, index: number) =>
                        <WpdfView key={`variante-${index}`} style={{...styles.col2}} pdf={isPdf}>
                            <WpdfView style={{...styles.cell, ...styles.cell2}} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{values[index] || null}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    )}
                </WpdfView>
            );
        });
    }

    renderHelpIcon(key: string, label: string): JSX.Element {
        return (
            <WHelpIcon
                data={this.props.data}
                styleDivProps={{ marginRight: 4, display: 'flex', alignSelf: 'center' }}
                styleProps={{ margin: 0 }}
                label={label || 'Hilfe'}
                helpKey={key || null}
                type='theme_info'
                style='theme_small'
                editBar
                useTheme
            />
        );
    }

    renderTabelle(): JSX.Element {
        const data: any = this.getData() || {};
        const isPdf: boolean = this.props.isPdf || false;
        const styles: any = this.getStyle();

        if (!Object.keys(data).length) {
            return (
                <WpdfView style={styles.hinweis} pdf={isPdf}>
                    <WpdfText pdf={isPdf}>Kein Ergebnis</WpdfText>
                </WpdfView>
            );
        }

        return (
            <WpdfView style={styles.tabelle} pdf={isPdf}>
                <WpdfView style={{...styles.row, ...styles.row_header}} pdf={isPdf}>
                    <WpdfView style={{...styles.col1, ...styles.col1_header}} pdf={isPdf}>
                        <WpdfView style={{...styles.cell, ...styles.cell_header, ...styles.cell1, ...styles.cell1_header}} pdf={isPdf}>
                            <WpdfText pdf={isPdf}>Wirtschaftliche Ergebnisse:</WpdfText>
                        </WpdfView>
                    </WpdfView>
                    {this.props.varianten.map((variante: any, index: number) =>
                        <WpdfView
                            key={`variante-${index}`}
                            style={{...styles.col2, ...styles.col2_header, ...(index === +this.props.variante ? styles.col_active : {})}}
                            pdf={isPdf}
                        >
                            <WpdfView style={{...styles.cell, ...styles.cell_header, ...styles.cell2, ...styles.cell2_header}} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>
                                    Variante {index + 1}:{!isPdf && <br />}{'\n'}
                                    <WpdfText style={styles.normal} pdf={isPdf}>
                                        {variante.split('\n').map((item: any, index: number) =>
                                            <React.Fragment key={`header-lines-${index}`}>
                                                {(index ? (!isPdf ? <br /> : '\n') : null)}{item}
                                            </React.Fragment>
                                        )}
                                    </WpdfText>
                                </WpdfText>
                            </WpdfView>
                        </WpdfView>
                    )}
                </WpdfView>
                {this.renderErgebnisse(data)}
            </WpdfView>
        );
    }
}
